import { LoadingOverlay } from '@mantine/core';

export const FullPageSpinner: React.FC = () => {
    return (
        <LoadingOverlay
            visible={true}
            zIndex={1000}
            overlayProps={{ radius: 'sm', blur: 2, pos: 'fixed' }}
        />
    );
};
